export const tutorLoading =  ({store})  => store.tutorReducer.loading;

export const tutorError =  ({store})  => store.tutorReducer.error;

export const tutorData =  ({store})  => store.tutorReducer.data;